import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { DataPagination } from '../../../Domain/Adapters';

export const ROLE_STATE_NAME = 'Role';

export interface RoleState {
	roles: IRole[];
	pagination: DataPagination;
	paginationInit: Pagination;
	loading: boolean;
}

export const initialStateRole: RoleState = {
	roles: [],
	pagination: {} as DataPagination,
	paginationInit: {} as Pagination,
	loading: false,
};
